import clsx from "clsx"
import FormInput from "components/auth/formInput"
import FormTextArea from "components/auth/formTextArea"
import { useSession } from "components/auth/useSession"
import { useForm } from "react-hook-form"
import toast from "react-hot-toast"
import styles from "./form.module.scss"

type Props = {
    comment_post_ID: number
    comment_parent?: number
    className?: string
    onSignIn: () => void
    isMobileApp?: boolean
}
export default function Component({ comment_post_ID, comment_parent, className, onSignIn, isMobileApp }: Props) {
    const { data: session } = useSession()
    const { register, handleSubmit, watch, reset, formState: { isSubmitting, errors } } = useForm({
        values: { comment_post_ID, comment_parent, comment_content: "", comment_author: session?.user?.name ?? "" },
    })

    const onSubmit = handleSubmit(async data => {
        const id = toast.loading("Παρακαλώ περιμένετε...")
        return fetch("/api/me/comments", {
            method: "POST",
            body: JSON.stringify(data),
        })
            .then(r => r.json())
            .then(r => {
                if (!r?.resp) throw new Error(r?.msg || "Σφάλμα.")

                reset({ comment_content: "" })
                toast.success("Ευχαριστούμε για το σχόλιό σας. Θα δημοσιευτεί σύντομα εφόσον πληροί τους κανόνες σχολιασμού.", { id })
            })
            .catch(e => toast.error(e.message, { id }))
    })

    const comment_content = watch("comment_content")
    const isUserLoggedIn = session?.user;
    const userCanLoggedIn = !isUserLoggedIn && !isMobileApp;
    return (
        <form onSubmit={onSubmit} className={clsx(styles.formCommentContainer, className)}>
            <input type="hidden" {...register("comment_post_ID")} />
            <input type="hidden" {...register("comment_parent")} />
            <div className={styles.formHeader}>
                <p>ΠΡΟΣΘΕΣΤΕ ΤΟ ΣΧΟΛΙΟ ΣΑΣ</p>
                <a href={isUserLoggedIn ? "/profile" : '#'} onClick={userCanLoggedIn ? () => onSignIn() : undefined} className={styles.userCnt}>
                    {session?.user?.image
                        ? <img src={session.user.image} width={23} height={23} alt={session.user.name!} referrerPolicy="no-referrer" />
                        : !isMobileApp && <i className="svgIcon"><svg><use xlinkHref="#IconUser"></use></svg></i>}
                    <span>{session ? session.user!.name! : userCanLoggedIn && "Συνδεθείτε"}</span>
                </a>
            </div>
            <FormInput
                readOnly={!!session}
                placeholder="Το όνομα σας"
                floatingInput={false}
                error={errors.comment_author?.message}
                {...register("comment_author", {
                    required: "Αυτό το πεδίο είναι υποχρεωτικό",
                    minLength: { value: 3, message: "Το όνομα πρέπει να έχει τουλάχιστον 3 χαρακτήρες" },
                    maxLength: { value: 30, message: "Το όνομα δεν μπορεί να ξεπερνά τους 30 χαρακτήρες" },
                })}
            />
            <FormTextArea
                rows={1}
                placeholder="Το σχόλιό σας"
                className="autoGrow"
                floatingInput={false}
                error={errors.comment_content?.message}
                {...register("comment_content", {
                    required: "Αυτό το πεδίο είναι υποχρεωτικό",
                    maxLength: { value: 1000, message: "Το σχόλιο δεν μπορεί να ξεπερνά τους 1000 χαρακτήρες" },
                })}
            />

            <div className="remainingChars">
                {`Xαρακτήρες: ${comment_content.length}/1000`}
            </div>
            <button className={clsx("cmnBtn", styles.submitButton)} disabled={isSubmitting}>Προσθηκη</button>
        </form>
    )
}